/* 倒入 api */
import axios from '@/utils/ajax/index';

/* 导出文件 api */
import fileExport from '@/utils/fileExport/index';


/* 患者列表 */
export const patients = (data) => {
  return axios({
    url: '/outpatient/patient/pagePatient',
    method: 'post',
    data,
  });
};

/* 历史病历列表 */
export const caseHistory = (params) => {
  return axios({
    url: '/outpatient/patient/listHistoryRecord',
    method: 'get',
    params,
  });
};


/* 获取病历检查治疗项 */
export const getHospitalExamList = (params) => {
  return axios({
    url: '/record/inquiryInfo/listHospitalExamByExamName',
    method: 'get',
    params,
    hideLoading: true,
  });
};

/* 通过下拉框查找药品 */
export const getPrescription = (data) => {
  return axios({
    url: '/drugsManage/drugs/prescription',
    method: 'post',
    data,
    hideLoading: true,
  });
};

// 查找患者信息下拉列表(诊所内)
export const getHospitalPatient = (params) => {
  return axios({
    url: '/record/inquiryInfo/listPatient',
    method: 'get',
    params,
  });
};

// 查找诊所检查治疗项下拉列表
export const getExamList = (params) => {
  return axios({
    url: '/record/inquiryInfo/listHospitalExamByExamName',
    method: 'get',
    params,
  });
};

/* 查找门诊病历详情 */
export const getRecord = (params) => {
  return axios({
    url: `/record/inquiryInfo/getRecord/${params.recordId}`,
    method: 'get',
    params,
  });
};

// 查询医生列表
export const getHospitalDoctor = (params) => {
  return axios({
    url: '/hospitalManage/doctor/listDoctorName',
    method: 'get',
    params,
    hideLoading: true,
  });
};

/* 单个患者历史病历 */
export const listHistoryRecordByPaitentId = (params) => {
  return axios({
    url: `/outpatient/patient/listHistoryRecordByPaitentId/${params.patientId}`,
    method: 'get',
    params,
    hideLoading: true,
  });
};

/* 患者详情 */
export const getPatientDetailById = (params) => {
  return axios({
    url: `/outpatient/patient/getPatientDetailById/${params.patientId}`,
    method: 'get',
    params,
  });
};

/* 保存门诊病历信息 */
export const saveRecord = (data) => {
  return axios({
    url: '/record/inquiryInfo/saveRecord',
    method: 'post',
    data,
  });
};

/* 最近处方 */
export const listRecentPrescription = (params) => {
  return axios({
    url: '/outpatient/patient/listRecentPrescription',
    method: 'get',
    params,
  });
};

/* 患者病历信息 */
export const getPatientRecord = (params) => {
  return axios({
    url: `/outpatient/patient/getPatientRecord/${params.recordId}`,
    method: 'get',
    params,
    hideLoading: true,
  });
};

/* 诊所下患者查询 */
export const listclinicPatientByNameOrPhone = (params) => {
  return axios({
    url: '/outpatient/patient/listclinicPatientByNameOrPhone',
    method: 'get',
    params,
    hideLoading: true,
  });
};

// 病历下载
export const down = (params) => {
  const path = '/drugsManage/flow/export';
  fileExport(path, params);
};

/* 病历上传 */
export const deleteFile = (data) => {
  return axios({
    url: '/upload/oss/delete',
    method: 'post',
    data,
  });
};

/* 详情病历附件上传 */
export const saveInquiryAttachment = (data) => {
  return axios({
    url: '/record/inquiryInfo/saveInquiryAttachment',
    method: 'post',
    data,
  });
};

export default {
  patients,
  caseHistory,
  getHospitalExamList,
  getHospitalPatient,
  getExamList,
  getHospitalDoctor,
  getPrescription,
  getRecord,
  listHistoryRecordByPaitentId,
  getPatientDetailById,
  saveRecord,
  listRecentPrescription,
  getPatientRecord,
  listclinicPatientByNameOrPhone,
  down,
  deleteFile,
  saveInquiryAttachment,
};
